import React, { useEffect, useState } from 'react';
import { View, ViewStyle } from 'react-native';

import styles from './true-false-container.style';
import { useFont } from '../../hooks/lesson-player.context';
import { useErrorSound } from '../../hooks/use-error-sound';
import { useSuccessSound } from '../../hooks/use-success-sound';
import { ChoiceBubble } from '../choice-bubble/choice-bubble';
import { ChoiceBubbleStatus } from '../choice-bubble/choice-bubble-status.enum';
import { ThemedText } from '../themed-text';

interface TrueFalseContainerProps {
  blocked?: boolean;
  containerStyle?: ViewStyle;
  correctAnswer: boolean;
  onAnswer?: (correct: boolean) => void;
  index?;
}

export function TrueFalseContainer({
  blocked = false,
  correctAnswer,
  containerStyle,
  onAnswer,
  index,
}: TrueFalseContainerProps) {
  const fonts = useFont();
  const correctSound = useSuccessSound();
  const incorrectSound = useErrorSound();
  const [choice, setChoice] = useState<boolean | null>(null);

  const answer = (choice: boolean) => {
    const correct = choice === correctAnswer;
    if (correct) {
      correctSound.play();
    } else {
      incorrectSound.play();
    }

    setChoice(choice);
    if (onAnswer) {
      onAnswer(correct);
    }
  };

  useEffect(() => {
    setChoice(null);
  }, [index, correctAnswer]);

  const getButtonStatus = (option) => {
    if (option === choice && correctAnswer === option) {
      return ChoiceBubbleStatus.CORRECT;
    } else if (option === choice && correctAnswer !== option) {
      return ChoiceBubbleStatus.INCORRECT;
    }

    return ChoiceBubbleStatus.DEFAULT;
  };

  return (
    <View style={[styles.container, containerStyle]}>
      <ChoiceBubble
        key="button-true"
        text="TRUE"
        status={getButtonStatus(true)}
        onPress={() => answer(true)}
        disabled={blocked}
        optionKey="1"
      />
      <ThemedText
        fontSize="small"
        style={[styles.textContainer, { ...fonts.secondary.regular }]}
        type="gray"
      >
        OR
      </ThemedText>
      <ChoiceBubble
        key="button-false"
        text="FALSE"
        status={getButtonStatus(false)}
        onPress={() => answer(false)}
        disabled={blocked}
        optionKey="2"
      />
    </View>
  );
}
